export class BehaviorForShatter {
    constructor(){
        console.log('behavior');
    }
    init(){
        console.log('behavior init');
    }
}